// extracted by mini-css-extract-plugin
export default {"infoContainer":"CommercialArguments-infoContainer_f359U"};